import { useState as u, useCallback as s } from "react";
function p({ initialValue: t = !1 } = {}) {
  const [o, e] = u(t), n = s(() => e(!0), []), c = s(() => e(!1), []), l = s(() => e((r) => !r), []);
  return { isOpen: o, open: n, close: c, toggle: l };
}
export {
  p as useDisclosure
};
